import QuillEditor from "../util/QuillEditor";
import styles from "./PageEdit.module.css"
import ImageSelector from "./ImageSelector";

import { useRef } from "react";

// component
import TextInput from "./TextInput";

export default function FrontPageItem({ sectionKey, header, text, image1Url, img1Text, img1Link,image2Url,img2Text,img2Link, updateField, parentSectionKey}) {
    

    return(
        <div className={styles.item}>
            <h2>{header}</h2>
            {/* Header Input */}
            <TextInput
                label={"Header:"}
                value={header}
                onChange={(e) => updateField(parentSectionKey, sectionKey+".header", e.target.value)}
            />

            {/* Content Editor */}
            <QuillEditor
                value={text || ""}
                onChange={(value) => updateField(parentSectionKey, sectionKey+".text", value)}
                placeholder="Write your content here..."
            />
            <h3 style={{paddingTop:'30px'}}>{img1Text}</h3>
            <div style={{width:'100%', display:'flex', justifyContent:'center', padding:'0px 30px 30px 30px'}}>
                <ImageSelector 
                    value={image1Url || ""}
                    updateField={(val) => updateField(parentSectionKey, sectionKey+".image1Url", val)}
                />
                <div style={{width:'100%', display:'flex', alignItems:'center', flexDirection:'column'}}>
                    <TextInput
                        label="Billede tekst:"
                        value={img1Text}
                        onChange={(e) => updateField(parentSectionKey, sectionKey+".img1Text", e.target.value)}
                    />
                    <TextInput
                        label="Billede link:"
                        value={img1Link}
                        onChange={(e) => updateField(parentSectionKey, sectionKey+".img1Link", e.target.value)}
                    />
                </div>
            </div>
            <h3>{img2Text}</h3>
            <div style={{width:'100%', display:'flex', justifyContent:'center', padding:'0px 30px 30px 30px'}}>
                <ImageSelector 
                    value={image2Url || ""}
                    updateField={(val) => updateField(parentSectionKey, sectionKey+".image2Url", val)}
                />
                <div style={{width:'100%', display:'flex', alignItems:'center', flexDirection:'column'}}>
                    <TextInput
                        label="Billede tekst:"
                        value={img2Text}
                        onChange={(e) => updateField(parentSectionKey, sectionKey+".img2Text", e.target.value)}
                    />
                    <TextInput
                        label="Billede link:"
                        value={img2Link}
                        onChange={(e) => updateField(parentSectionKey, sectionKey+".img2Link", e.target.value)}
                    />
                </div>
            </div>
            
        </div> 
    );
}